import * as React from 'react'
import * as Header from '../Header'
import withAuthorization from 'components/Session/withAuthorization'
import { compose } from 'recompose'
import Base from './Base'

const Component = ({
  children,
  style,
  client,
  back = false,
  renderLeft = null,
  standalone = false,
}) => {
  return (
    <Base style={style}>
      <Header.Mini
        back={back}
        client={client}
        renderLeft={renderLeft}
        standalone={standalone}
      />
      {children}
    </Base>
  )
}

const ComposedComponent = compose(withAuthorization(true))(Component)

export default ComposedComponent
